var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"variant":"dark","show":""}},[_c('b',[_vm._v("Heads up!")]),_vm._v("\n  This project works best on large screens.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }